import { boolean, number, object, string } from 'yup'

export const validationSchema = object().shape({
  active: boolean().required(),
  include_original_approvers: boolean().required(),
  code: string().trim().required(),
  name: string().trim().required(),
  organization_id: number().typeError().required(),
  // policy_approval_exception_trees: array().of(object().shape({})),
  policy_approval_id: number().typeError().notRequired(),
  policy_approval_rule_id: number().typeError().notRequired(),
  policy_request_air_rule_id: number().typeError().notRequired(),
  policy_request_general_rule_id: number().typeError().notRequired(),
  policy_request_hotel_rule_id: number().typeError().notRequired(),
  policy_request_vehicle_rule_id: number().typeError().notRequired()
})
